<template>
  <section>
    <ProductsViewError
      v-if="currentStatus.isError"
      @on-retry="getProductsData"
    />
    <template v-else>
      <ProductsViewHero :loading="currentStatus.isLoading" :hero="hero" />
      <ProductsViewContent
        class="section content"
        :loading="currentStatus.isLoading"
        :cards="cards"
      />
      <ProductsViewFooter
        class="section footer"
        :loading="currentStatus.isLoading"
        :services="services"
      />
    </template>
  </section>
</template>
<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue';

import {
  ProductsViewHero,
  ProductsViewContent,
  ProductsViewFooter,
  ProductsViewError
} from './components';

import { EProductsViewStatus } from './types';
import {
  getHero,
  getSummary,
  IHero,
  ISummary
} from '@/modules/products/services/products';

const status = ref(EProductsViewStatus.Loading);

const hero = ref<IHero>({} as IHero);
const summary = ref<ISummary>({
  products: Array(5).fill({}),
  services: []
} as ISummary);

const currentStatus = computed(() => ({
  isLoading: status.value === EProductsViewStatus.Loading,
  isError: status.value === EProductsViewStatus.Error
}));

const cards = computed(() => {
  return summary.value.products;
});

const services = computed(() => {
  return summary.value.services;
});

async function getProductsData() {
  try {
    status.value = EProductsViewStatus.Loading;

    const [header, content] = await Promise.all([getHero(), getSummary()]);

    hero.value = header;
    summary.value = content;
    status.value = EProductsViewStatus.Loaded;
  } catch {
    status.value = EProductsViewStatus.Error;
  }
}
onMounted(getProductsData);
</script>
<style lang="less" scoped>
.section {
  margin: 0 auto;
  padding: 0 @size-spacing-x400;
  max-width: calc(1008px + @size-spacing-x600);

  &.content {
    margin-top: @size-spacing-x1200;
    margin-bottom: @size-spacing-x1200;
  }

  &.footer {
    margin-bottom: @size-spacing-x1200;
  }
}
</style>
